import * as $ from 'jquery';
import 'bootstrap';
import 'datepicker';
import 'selectize';
import * as moment from 'moment';
import { bookingFormCommon } from "./c005-bookingform-common";
import { bookingFormSubmit } from "./c005-bookingform-submission";
import { bookingFormInfant } from "./c005-bookingform-infant";
import { adobeDataLayerWrapper } from "./adobeDataLayerMethod";
import { wcagOptions } from "./wcag";
import {headerContent} from "./c002";

export class mholidayBookingFormContent {
	private bcommon = new bookingFormCommon();
	private bookingFormSubmit = new bookingFormSubmit();
	private wcag = new wcagOptions();

	$siteCode: string = '';
	$officeCode: string = '';
	$error:Array<string> = [];

	$instance:any;

	$scope:any                  = $('#mholiday-ibe--container');
	$scopeMob:any               = $('#mobile-bookflight--container');

	toCityFromCookie:any;

	// value for populating to to location field on from location update complete
	toPrepop:string = null;

	// for recent search clicked state to prevent auto focus to the next field with ibe search
	recentSearchActive:boolean = false;

	// Handle passenger type if UK city selected for IBE search
	isUkCitySelectedForIbeSearch:boolean = false;

	/**
	 * @function nav
	 * Initialize IBE Booking navigation
	 * for navbar ibe only
	 * !!! Global
	 */
	nav(): void {
		let _self = this;
		let $checkIn:any         = $('#check-in--container');
		let $viewBooking:any     = $('#view-booking--container');
		let $flightStatus:any    = $('#flight-status--container');
		let $login:any           = $('#login-container');
		let $loggedin:any        = $('#logged-in-user-menu');
		let $checkInMob:any      = $('#mob-checkin--container');
		let $viewBookingMob:any  = $('#mob-viewbooking--container');
		let $flightStatusMob:any = $('#mob-flightstatus--container');
		let $loginMob:any        = $('#mob-login--container');
		let $loggedinMob: any    = $('#mob-logged-in-user-menu');
		let $mhStay: any         = $('#ibe-stay--container');
		let $mhUpgrade: any      = $('#mhupgrade-in--container');
		let $bookingWidget: any  = $('#book-flight--container');
		let $flightUpgrade : any = $('#view-upgrade');
		let $moreLinks: any 	 = $('#more-links--container');
		let $moreLinksMholidays: any 	 = $('#more-links--container .mhholidays');

		let $ibeNav:any;
		if($('.ibe-refresh').length >0) {
			$ibeNav     = $('.desktop #bookingNav');
		}
		else {
			$ibeNav     = $('#bookingNav');
		}
		let $ibeNavList:any = $('#bookingNav li');

		let $errorValidationGen:any     = $('.error-validation');
		let $bookingFormTitle:any       = $('.booking-form--title');
		let $dateFormTitle:any          = $('.date-form--title');
		let $bookdateSelectorGen:any    = $('.book-date--selector');
		let $couponCodeGen:any          = $('.couponCode');
		let $redemptionLogin:any        = $('.redemption-login .form-group');

		

		$('.child-age-grp').hide();
		// IBE Navigation show/hide detailed container
		$ibeNav.find('.mholidays').on('click', () => {
			adobeDataLayer.push('click', {
                'clickName': 'click:tab-click:top-nav-flight-and-hotel',
                'componentType': 'tab',
                'componentName': 'Flight And Hotel Top Menu',
                'componentID': '',
				'attributes': []
            });
			let $fromLocation:any        =   _self.$scope.find('.mholidays-ibe-from--location');
			let $fromSelectize:any       =   $fromLocation.parent().find('.selectize-control .selectize-input');
			let $toLocation:any          =   _self.$scope.find('.mholidays-ibe-to--location');
			let $toSelectize:any         =   $toLocation.parent().find('.selectize-control .selectize-input');
			let $mcityToSelectInput:any  =   $('.multi-cityTrip--Container').find('select.mc-to--location');

			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.mholidays').parent().addClass('selected');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header #mab-bookingnav .navbar-default').addClass('mholidays-navbar');
			}
		

			let curInstance = _self.$instance;
			// desktop stuff
			_self.$scope.show();
			$checkIn.hide();
			$viewBooking.hide();
			$flightStatus.hide();
			$flightUpgrade.hide();
			$login.hide();
			$bookingWidget.hide();
			$loggedin.addClass('hidden');
			_self.expandIbe(curInstance);
			// mobile stuff
			_self.$scopeMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$moreLinks.hide();

			// form stuff
			$errorValidationGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$dateFormTitle.removeClass('has-error');
			$bookdateSelectorGen.removeClass('has-error');
			$fromSelectize.removeClass('has-error');
			$toSelectize.removeClass('has-error');
			$mcityToSelectInput.removeClass('has-error');
			$couponCodeGen.removeClass('has-error');
			$redemptionLogin.removeClass('has-error');
		});

		$moreLinksMholidays.on('click', () => {
			let $fromLocation:any        =   _self.$scope.find('.mholidays-ibe-from--location');
			let $fromSelectize:any       =   $fromLocation.parent().find('.selectize-control .selectize-input');
			let $toLocation:any          =   _self.$scope.find('.mholidays-ibe-to--location');
			let $toSelectize:any         =   $toLocation.parent().find('.selectize-control .selectize-input');
			let $mcityToSelectInput:any  =   $('.multi-cityTrip--Container').find('select.mc-to--location');

			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.mholidays').parent().addClass('selected');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header #mab-bookingnav .navbar-default').addClass('mholidays-navbar');
			}
		

			let curInstance = _self.$instance;
			// desktop stuff
			_self.$scope.show();
			$checkIn.hide();
			$viewBooking.hide();
			$flightStatus.hide();
			$flightUpgrade.hide();
			$login.hide();
			$bookingWidget.hide();
			$loggedin.addClass('hidden');
			_self.expandIbe(curInstance);
			// mobile stuff
			_self.$scopeMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$moreLinks.hide();

			// form stuff
			$errorValidationGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$dateFormTitle.removeClass('has-error');
			$bookdateSelectorGen.removeClass('has-error');
			$fromSelectize.removeClass('has-error');
			$toSelectize.removeClass('has-error');
			$mcityToSelectInput.removeClass('has-error');
			$couponCodeGen.removeClass('has-error');
			$redemptionLogin.removeClass('has-error');
		});
	}

	init(): void { 
		let _self = this;

		let $ibeNav:any;
		if($('.ibe-refresh').length >0) {
			$ibeNav     = $('.desktop #bookingNav');
		}
		else {
			$ibeNav     = $('#bookingNav');
		}
		let $desktopIbe:any = $('.desktop#mab-bookingnav');

		let $passengerDetails:any       = $('[data-booking-passenger-details]');
		let $passengerDetailsActive:any = $('[data-booking-passenger-details-selected]');

		const topNavIbe = $('.desktop#mab-bookingnav [data-ibe--mholidays]');
		// hide all passenger fields on load
		$passengerDetailsActive.hide();
		$passengerDetails.addClass('passenger-focused');
		$passengerDetails.show();
		$passengerDetails.find('.total-passengers').show();

		// set z-index of ibe bar so that it supercedes the rest of the standalone ibes appearing on the page later
		// $desktopIbe.closest('.container')
		// 	.css({'z-index': 600})
		// 	.attr({'data-component': 'c005'});

		// also set z-index of navbar so that it shows when not expanded (mobile)
		$('.mobile#mab-bookingnav').find('.mobile-ibe.navbar')
			.css({'z-index': 600});
			
			let flightHotelTab1 = $('.payment-method-options').find('.flight_hotel');
			let hotelTab = $('.payment-method-options').find('.hotel');
			let viewMoreTab = $('.payment-method-options').find('.view_more');


			flightHotelTab1.click(function () {
				$('.payment-method-options label').removeClass('selected');
				$('.flight_hotel').parent().addClass('selected');
			});
			hotelTab.click(function () {
				$('.payment-method-options label').removeClass('selected');
				$('.hotel').parent().addClass('selected');
			});
			viewMoreTab.click(function () {
				$('.payment-method-options label').removeClass('selected');
				$('.view_more').parent().addClass('selected');
			});

			let flightHotelTab = _self.$scope.find('input[name="flight_hotel"]');

			flightHotelTab.click(function(){
				let $errorEls = _self.$scope.find('.has-error');
				let $errorValidation = _self.$scope.find('.error-validation').first();

				$errorValidation.hide().find('.mobile-validation--content').empty();
				$errorEls.each(function(){
					$(this).removeClass('has-error');
				});
				let $ibeNowDate:any      = new Date();
				let depRange: any;
				let $calDate:any;
				let retRange: any;
				let flightHotelVal = _self.$scope.find('input[name="flight_hotel"]:checked').val();
				
				if ($('.enrich-revamp').length > 0) {
					_self.$scope.find('input[name="flight_hotel"]').parent().removeClass('active');
					$(this).parent().addClass('active');
				}
				if(flightHotelVal == 'hotel'){
					_self.$scope.find('.trip-container').show();
					_self.$scope.find('.flight-container').hide();
					_self.$scope.find('.hotel-container').show();
					if ($('.hotel-container .departureDate').val() === '') {
						depRange = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate() + parseInt($('.hotel-container .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
						$('.hotel-container .departureDate').datepicker('option', 'maxDate', depRange);
						$('.hotel-container .returnDate').datepicker('option', 'maxDate', depRange);
					} else {
						$calDate = new Date($('.hotel-container .departureDate').datepicker('getDate'));
						let $ibeMHotelReturDateInterveldays: any = $('[data-home-hotel-returDate-intervel]').length > 0 ? parseInt($('[data-home-hotel-returDate-intervel]').attr('data-home-hotel-returDate-intervel')) : 14;
						retRange = new Date($calDate.getFullYear(), $calDate.getMonth(), $calDate.getDate() + $ibeMHotelReturDateInterveldays, 0, 0, 0, 0);
						$('.hotel-container .returnDate').datepicker('option', 'maxDate', retRange);
					}				
				}else{
					_self.$scope.find('.hotel-container').hide();
					_self.$scope.find('.trip-container').show();
					_self.$scope.find('.flight-container').show();
					if ($('.flight-container .departureDate').val() === '') {
						depRange = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate() + parseInt($('.flight-container .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
						$('.flight-container .departureDate').datepicker('option', 'maxDate', depRange);
						$('.flight-container .returnDate').datepicker('option', 'maxDate', depRange);
					} else {
						$calDate = new Date($('.flight-container .departureDate').datepicker('getDate'));
						let $ibeMHFlightHotelReturDateInterveldays: any = $('[data-home-flighthotel-returDate-intervel]').length > 0 ? parseInt($('[data-home-flighthotel-returDate-intervel]').attr('data-home-flighthotel-returDate-intervel')) : 14;
						retRange = new Date($calDate.getFullYear(), $calDate.getMonth(), $calDate.getDate() + $ibeMHFlightHotelReturDateInterveldays, 0, 0, 0, 0);
						$('.flight-container .returnDate').datepicker('option', 'maxDate', retRange);
					}
				}
			});
	}

	/**
	 * @function closeIbeHandler
	 * for navbar ibe only
	 */
	closeIbeHandler(): void {
		let _self = this;
		let $ibeNavList:any = $('#bookingNav li');
		let $closeIbe:any   = $('.close-booking');
		let ibeClicked:boolean = false;

		// IBE Close detailed container
		$closeIbe.on('click', (e:any) => {
			// clear error on closing form
			// find out which form is being closed and switch to function for clearing error messages
			// - clear all error classes
			// - empty error summary
			let $whichForm:string = $(e.target).closest('.ibe-form--container')[0].id;

			switch($whichForm) {
				case 'book-flight--container': {
					let $errorEls = _self.$scope.find('.has-error');
					let $errorValidation = _self.$scope.find('.error-validation').first();

					$errorValidation.hide().find('.mobile-validation--content').empty();
					$errorEls.each(function(){
						$(this).removeClass('has-error');
					});
				}
				break;
				case 'mobile-bookflight--container': {
					let $errorEls = _self.$scopeMob.find('.has-error');
					let $errorValidation = _self.$scopeMob.find('.error-validation').first();

					$errorValidation.hide().find('.mobile-validation--content').empty();
					$errorEls.each(function(){
						$(this).removeClass('has-error');
					});

					// reset to show return tripflow by default
					let bdsRetTrip: any = _self.$scopeMob.find('.book-date--selector.returnTrip');
					let bdsOneTrip: any = _self.$scopeMob.find('.book-date--selector.oneWayTrip');

					bdsRetTrip.show();
					bdsOneTrip.hide();
				}
				break;
				case 'check-in--container': {
					// todo: error clearing on submission
				}
				break;
				case 'mob-checkin--container': {
					// todo: error clearing on submission
				}
				break;
				case 'view-booking--container': {
					// todo: error clearing on submission
				}
				break;
				case 'mob-viewbooking--container': {
					// todo: error clearing on submission
				}
				break;
				case 'flight-status--container': {
					// todo: error clearing on submission
				}
				break;
				case 'mob-flightstatus--container': {
					// todo: error clearing on submission
				}
				break;
				default:
				break;
			}
			//console.log();

			// specifically target navbar ibes only
			let $ibeNotLoggedIn = $('.desktop#mab-bookingnav .ibe-form--container:not(.user-account-menu), .mobile#mab-bookingnav .ibe-form--container:not(.user-account-menu)');
			$ibeNotLoggedIn.hide();
			$ibeNavList.removeClass('selected');
		});

		$(document).click(function(e: any) {
			if (!ibeClicked && !($("#ui-datepicker-div").datepicker( "widget" ).is(":visible")) && !($.magnificPopup.instance.isOpen) && $('.cabin-class').attr('data-ibeclicked') != 'true' && $('#mob-flightstatus--container .status-from--location').attr('data-ibeclicked') != 'true' &&  $('#flight-status--container').css('display') != 'block' && $('.ibe-refresh').length == 0) {
				let $ibeNavList:any = $('#bookingNav li');
				if(!$(e.target).is('#ibeWrapper')) {
					let $ibeNotLoggedIn = $('.desktop#mab-bookingnav .ibe-form--container:not(.user-account-menu), .mobile#mab-bookingnav .ibe-form--container:not(.user-account-menu)');
					$ibeNotLoggedIn.hide();
					$ibeNavList.removeClass('selected');
				}
			}
			ibeClicked = false;     
			$('.cabin-class').removeAttr('data-ibeclicked');   
			$('#mob-flightstatus--container .status-from--location').removeAttr('data-ibeclicked');
		});
		if ($(".mfp-ready").length > 0)
		{
			ibeClicked = true;
		}

		$('#ibeWrapper, #ibeMobWrapper, #bookingNav, #navbarNav, #mobile-location-popup, #mobile-to-location-popup, #fs-from-location-popup, #fs-to-location-popup').click(function(e: any) {
			ibeClicked = true;
		});

		$(document).on('click', '.mab-nav--overlay, .ibe-freesidetrip_popup,.ui-datepicker-next, .ui-datepicker-prev, .ui-datepicker-close, .alert-row-container, .mobileapp, .container--main-header, .cc-window, .ui-datepicker, .enrich-header', function () {
			ibeClicked = true;
		});
	}

	/**
	 * @function setInstance
	 * - set current booking form instance
	 * @param {any} obj - current form object
	 * !!! Properly scoped
	 */
	setInstance(obj:any) {
		let _self = this;
		return _self.$instance = $(obj);
	}

	/**
	 * @function getInstance
	 * retrieve currently assigned booking form instance
	 * @return {any} - current instance
	 */
	getInstance():any {
		let _self = this;
		console.log('this instance');
		console.log(_self.$instance);
		return;
	}

	/**
	 * @function ibeTripType
	 * IBE trip type container
	 * !!! Properly scoped
	 */
	ibeTripType(): void {
		let _self = this;

		let $infantAlertContainer:any = $('#infant-alert--container');
		let $warningAccepted:any = $infantAlertContainer.find('input[name="infant_warning"]');

		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		let returnDate = '';
		// return trip click event (desktop)
		_self.$instance.find('.trip-type--container .returnTrip').off('click.triptype').on('click.triptype', () =>{
			returnTripClickHandler(this, curInstance);
		});

		// one way trip click event (desktop)
		_self.$instance.find('.trip-type--container .oneWayTrip').off('click.triptype').on('click.triptype', () =>{
			oneWayTripClickHandler(this, curInstance);
		});

		// multi trip click event (desktop)
		_self.$instance.find('.trip-type--container .multiCityTrip').off('click.triptype').on('click.triptype', () =>{
			multiTripClickHandler(this, curInstance);
		});

		/*
		* return trip event handler
		* @param {any} el    [target element]
		* @param {any} instance [element parent instance]
		*/
		function returnTripClickHandler(el:any, instance:any) {
			let singleTripSubmitBtn:any = instance.find('.mholidays-single-city--bookflight');
			let multiTripSubmitBtn:any  = instance.find('.multi-city--bookflight');
			let rdmSingleSubmitBtn:any = instance.find('.redemption-submit-btn-single');
			let rdmMultiSubmitBtn:any  = instance.find('.redemption-submit-btn-multi');
			let returnTripDepartureDate:any = instance.find('.departureDate');

			// clear select state on all trip type selectors
			instance.find('.trip-type--container').find('li').removeClass('selected');
			instance.find('.trip-type--container').find('li.returnTrip').addClass('selected');

			// toggle display of OnD fields
			instance.find('.book-date--selector.returnTrip').show();
			instance.find('.book-date--selector.oneWayTrip').hide();
			instance.find('.single-cityTrip--Container').show();
			instance.find('.multi-cityTrip--Container').hide();

			// show coupon code field (hide if cug)
			instance.find('.couponCode').show();

			// show redemption payment methods
			instance.find('input[name="cash_miles_type"][value="miles"]').parent().fadeIn(300);
			instance.find('input[name="cash_miles_type"][value="cash_miles"]').parent().fadeIn(300);

			// remove filled state on input labels
			instance.find('.dep-title').removeClass('input-filled');
			instance.find('.ret-title').removeClass('input-filled');

			// empty input field
			//instance.find('.departureDate').val('');
			//instance.find('.returnDate').val('');
			if (returnDate != '') {
				instance.find('.returnDate').val(returnDate);
			}
			// toggle single/multi booking state
			instance.find('.search-container').removeClass('multiCityActive');

			// toggle display of submit buttons
			singleTripSubmitBtn.show();
			multiTripSubmitBtn.hide();
			rdmSingleSubmitBtn.show();
			rdmMultiSubmitBtn.hide();

			// reset infant warning state on changing triptype
			$warningAccepted.val('');

			// Retain the departure date set for single trip
			returnTripDepartureDate.datepicker('setDate', $('#oneWayTripDateSelector').find('.departureDate').val()).trigger('blur', 'input');
		}

		/**
		* one way trip event handler
		* @param {any} el    [target element]
		* @param {any} instance [element parent instance]
		*/
		function oneWayTripClickHandler(el:any, instance:any) {
			let singleTripSubmitBtn:any = instance.find('.mholidays-single-city--bookflight');
			let multiTripSubmitBtn:any  = instance.find('.multi-city--bookflight');
			let rdmSingleSubmitBtn:any = instance.find('.redemption-submit-btn-single');
			let rdmMultiSubmitBtn:any  = instance.find('.redemption-submit-btn-multi');
			let oneWayTripDepartureDate = instance.find('.departureDate');

			// clear select state on all trip type selectors
			instance.find('.trip-type--container').find('li').removeClass('selected');
			instance.find('.trip-type--container').find('li.oneWayTrip').addClass('selected');

			// toggle display of OnD fields
			instance.find('.book-date--selector.returnTrip').hide();
			instance.find('.book-date--selector.oneWayTrip').show();
			instance.find('.single-cityTrip--Container').show();
			instance.find('.multi-cityTrip--Container').hide();

			// show coupon code field
			instance.find('.couponCode').show();

			// show redemption payment methods
			instance.find('input[name="cash_miles_type"][value="miles"]').parent().fadeIn(300);
			instance.find('input[name="cash_miles_type"][value="cash_miles"]').parent().fadeIn(300);

			// remove filled state on input labels
			instance.find('.dep-title').removeClass('input-filled');
			instance.find('.ret-title').removeClass('input-filled');

			// empty input field
			//instance.find('.departureDate').val('');
			//instance.find('.returnDate').val('');
			returnDate = instance.find('.returnDate').val();
			instance.find('.returnDate').val('');
			// toggle single/multi booking state
			instance.find('.search-container').removeClass('multiCityActive');

			// toggle display of submit buttons
			singleTripSubmitBtn.show();
			multiTripSubmitBtn.hide();
			rdmSingleSubmitBtn.show();
			rdmMultiSubmitBtn.hide();

			// reset infant warning state on changing triptype
			$warningAccepted.val('');

			// Retain the departure date selected for return trip
			oneWayTripDepartureDate.datepicker('setDate', $('#returnTripDateSelector').find('.departureDate').val()).trigger('blur', 'input');
		}

		/**
		* one way trip event handler
		* @param {any} el    [target element]
		* @param {any} instance [element parent instance]
		*/
		function multiTripClickHandler(el:any, instance:any) {
			let singleTripSubmitBtn:any = instance.find('.mholidays-single-city--bookflight');
			let multiTripSubmitBtn:any  = instance.find('.multi-city--bookflight');
			let rdmSingleSubmitBtn:any = instance.find('.redemption-submit-btn-single');
			let rdmMultiSubmitBtn:any  = instance.find('.redemption-submit-btn-multi');

			// clear select state on all trip type selectors
			instance.find('.trip-type--container').find('li').removeClass('selected');
			instance.find('.trip-type--container').find('li.multiCityTrip').addClass('selected');

			// toggle display of OnD fields
			instance.find('.single-cityTrip--Container').hide();
			instance.find('.multi-cityTrip--Container').show();

			// hide coupon code (no coupon available for multicity)
			instance.find('.couponCode').hide();

			// hide redemption payment method and uncheck it
			instance.find('input[name="cash_miles_type"][value="miles"]').prop('checked', false).parent().fadeOut(300);
			instance.find('input[name="cash_miles_type"][value="cash_miles"]').prop('checked', false).parent().fadeOut(300);
			instance.find('input[name="cash_miles_type"][value="cash"]').prop('checked', true);

			// remove filled state on input labels
			instance.find('.dep-title').removeClass('input-filled');
			instance.find('.ret-title').removeClass('input-filled');

			// empty input field
			//instance.find('.departureDate').val('');
			//instance.find('.returnDate').val('');

			// toggle single/multi booking state
			instance.find('.search-container').addClass('multiCityActive');

			// toggle display of submit buttons
			singleTripSubmitBtn.hide();
			multiTripSubmitBtn.show();
			rdmSingleSubmitBtn.hide();
			rdmMultiSubmitBtn.show();

			// reset infant warning state on changing triptype
			$warningAccepted.val('');
		}
	}

	/**
	 * @function passengerType
	 * IBE Passenger type container
	 * !!! Properly scoped
	 */
	passengerType(): void {
		let _self = this;

		let $passengerDetails:any       = _self.$instance.find('[data-booking-passenger-details]');
		let $passengerDetailsActive:any = _self.$instance.find('[data-booking-passenger-details-selected]');
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		$passengerDetails.on('click', () => {
			$(this).hide();
			$passengerDetailsActive.show();
			curInstance.find('.book-date--selector').removeClass('datepicker-selected');
		});

		$passengerDetailsActive.mouseleave((evt:any) => {
			if(evt.relatedTarget != null){
				$(this).hide();
				$passengerDetailsActive.hide();
				$passengerDetails.addClass('passenger-focused');
				$passengerDetails.show();
				$passengerDetails.find('.total-passengers').show();
			}	
		});

		$passengerDetailsActive.on('touchend', function(e:any) {
			if (!($(e.target).closest('.booking-person').length || $(e.target).is('.booking-person'))) {
			$passengerDetailsActive.hide();
			return false;
			} else {
				return true;
			}
		});
	}

	/**
	 * @function swapFromToLocation
	 * !!! Properly scoped
	 */
	swapFromToLocation(): void {
		let _self = this;
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		_self.$instance.find('.flight-trip--icon').on('click', function() {
			let $fromLocationGetVal:any = curInstance.find('.mholidays-ibe-from--location')[0].selectize.getValue();
			let $toLocationGetVal:any   = curInstance.find('.mholidays-ibe-to--location')[0].selectize.getValue();

			$(this).toggleClass("rotate-180");

			curInstance.find('.mholidays-ibe-from--location')[0].selectize.setValue($toLocationGetVal);
			curInstance.find('.mholidays-ibe-to--location')[0].selectize.setValue($fromLocationGetVal);
		});
	}


	/**
	 * @function calendarComponent
	 * Calendar component for single trip and multi city trip
	 * !!! Properly scoped
	 */
	calendarComponent(): void {
		let _self = this;

		let $ibeNowDate:any      = new Date();
		let $ibeTodayDate:any    = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate(), 0, 0, 0, 0);
		let $ibeMHHMindays: any = $('[data-mhh-min-days]').length > 0 ? parseInt($('[data-mhh-min-days]').attr('data-mhh-min-days')) : 7;
		let $ibeTomorrowDate:any    = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate() + $ibeMHHMindays, 0, 0, 0, 0);
		let maxDays: any = $('[data-ibe-datepicker-days]').length > 0 ? parseInt($('[data-ibe-datepicker-days]').attr('data-ibe-datepicker-days')) : 361;
		let $ibeMaxLimitDate: any = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate() + maxDays, 0, 0, 0, 0);
		let depRange: any;
		let flightHotelVal = _self.$instance.find('input[name="flight_hotel"]:checked').val();
		if (flightHotelVal == 'hotel') {
			depRange = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate() + parseInt($('.hotel-container .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
		}
		else {
			depRange = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate() + parseInt($('.flight-container .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
		}
        let retRange: any = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate() + 14, 0, 0, 0, 0);
		let $calStartDate:any    = new Date(_self.$instance.find('.departureDate').datepicker('getDate'));
		let $calEndDate:any      = new Date(_self.$instance.find('.returnDate').datepicker('getDate'));

		let $curDatepickerInst:any;
		let $curDatepickerTitle:string;

		let $tripTypeContainer:any = _self.$instance.find('.trip-type--container');

		let $highlightDays:any = (date: any) => {
			var startDate:any = new Date(_self.$instance.find('.departureDate').datepicker('getDate'));
			var endDate:any   = new Date(_self.$instance.find('.returnDate').datepicker('getDate'));

			var modClasses:string = '';
			var modAltText:string = '';

			if ((startDate <= date) && (date <= endDate)) {
				modClasses += 'ui-state-selected';
				modAltText = 'Trip dates';
			}

			// highlight departure date
			if (Date.parse(startDate) == Date.parse(date)) {
				// console.log('start date match');
				modClasses += ' ' + 'ui-state-departureDate';
				modAltText = 'Departure date';
			}

			// highlight return date
			if (Date.parse(endDate) == Date.parse(date)) {
				// console.log('end date match');
				modClasses += ' ' + 'ui-state-returnDate';
				modAltText = 'Return date';
			}

			// console.log(modClasses);

			return [true, modClasses, modAltText];
		}
		var $ipad_not:any;
		if (navigator.userAgent.match(/iPad/i)) {				
			$ipad_not=1;
		} else {
			$ipad_not=2;
		}
		// Single trip calendar - return trip
		let $dateFormat:any = 'd M yy',
			$departDate = _self.$instance.find('.departureDate').datepicker({
				showButtonPanel: true,
				closeText: 		 '<i class="fa fa-times" aria-hidden="true"></i>',
				minDate: 		 $ibeTomorrowDate,
				dateFormat: 	 'd M yy',
				maxDate: 		 depRange,
				numberOfMonths:  $ipad_not,
				firstDay: 1,
				onClose: function(selectedDate: any) {
					let nextDay:any = new Date(selectedDate);
					nextDay.setDate(nextDay.getDate() + 1);
					let depDate = getDate(this);
					depDate = depDate ? depDate : $ibeNowDate;
					let flightHotelVal = _self.$instance.find('input[name="flight_hotel"]:checked').val();
					if (flightHotelVal == 'hotel') {
						depRange = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate() + parseInt($('.hotel-container .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
						$('.hotel-container .returnDate').datepicker("option", "minDate", ((selectedDate && selectedDate != '') ? nextDay : $ibeTomorrowDate));
					}
					else {
						depRange = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate() + parseInt($('.flight-container .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
						$('.flight-container .returnDate').datepicker("option", "minDate", ((selectedDate && selectedDate != '') ? nextDay : $ibeTomorrowDate));
					}
					
					if (selectedDate == '') {
						$('.returnDate').datepicker('option', 'maxDate', depRange);
					} else {
						if ($('.hotel-container').css('display') == 'block') {
							let $ibeMHotelReturDateInterveldays: any = $('[data-home-hotel-returdate-intervel]').length > 0 ? parseInt($('[data-home-hotel-returdate-intervel]').attr('data-home-hotel-returdate-intervel')) : 14;
							$('.hotel-container .returnDate').datepicker('option', 'maxDate', new Date(depDate.getFullYear(), depDate.getMonth(), depDate.getDate() + $ibeMHotelReturDateInterveldays, 0, 0, 0, 0));
						}
						else if($('.flight-container').css('display') == 'block'){
							let $ibeMHFlightHotelReturDateInterveldays: any = $('[data-home-flighthotel-returDate-intervel]').length > 0 ? parseInt($('[data-home-flighthotel-returDate-intervel]').attr('data-home-flighthotel-returDate-intervel')) : 14;
							$('.flight-container .returnDate').datepicker('option', 'maxDate', new Date(depDate.getFullYear(), depDate.getMonth(), depDate.getDate() + $ibeMHFlightHotelReturDateInterveldays, 0, 0, 0, 0));	
						}
						else{
							$('.returnDate').datepicker('option', 'maxDate', new Date(depDate.getFullYear(), depDate.getMonth(), depDate.getDate() + 14, 0, 0, 0, 0));
						}
						
					}					
				},
				beforeShow: function(ele:any, obj:any) {
					_self.$instance.find('#ui-datepicker-div').removeClass('multicityTrip');
					$curDatepickerInst  = obj.dpDiv[0];
					$curDatepickerTitle = ele.dataset.datepickerTitle;
				},
				afterShow: function() {
					_self.bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
				}
			})
			.on('change', function() {
				//$returnDate.datepicker('option', 'minDate', getDate(this));
				$returnDate.datepicker('setDate', null);
				let $nextReturnDate:any = $(this).next('.returnDate');

				// if return date == empty, focus on field
				if ($nextReturnDate.val() === "") {
					window.setTimeout($.proxy(function() {
						$nextReturnDate.focus();
					}, this), 100);
				} else {
					// do stuff
				}
			}),
			$returnDate = _self.$instance.find('.returnDate').datepicker({
				showButtonPanel: true,
				closeText: 		 '<i class="fa fa-times" aria-hidden="true"></i>',
				dateFormat: 	 'd M yy',
				minDate: 		 $ibeTomorrowDate,
				maxDate: 		 depRange,
				numberOfMonths: $ipad_not,
				firstDay: 1,
				beforeShow: function(ele:any, obj:any) {
					_self.$instance.find('#ui-datepicker-div').removeClass('multicityTrip');
					_self.bcommon.appendDatepickerTitle('Please select your return date', obj.dpDiv);
					$curDatepickerInst  = obj.dpDiv[0];
					$curDatepickerTitle = ele.dataset.datepickerTitle;
				},
				afterShow: function() {
					_self.bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
				}
			})
			.on('change', function() {
				// $departDate.datepicker('option', 'maxDate', getDate(this));
				_self.$instance.find('[data-booking-passenger-details-selected]').show();
			});

		/**
		 * Parse single date datepicker value from element
		 */
		let getDate:any = ($element: any) => {
			let $getDate: any;
			try {
				$getDate = $.datepicker.parseDate($dateFormat, $element.value);
			} catch(error) {
				//console.error(error);
				$getDate = null;
			}
			return $getDate;
		}

		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		// Hightlight Datepicker TD colours
		_self.$instance.find('#ui-datepicker-div').on('mouseover','td', () => {
			if (curInstance.find('.trip-type--container .returnTrip').hasClass('selected') &&
				curInstance.find('.departureDate').val()) {
				let _datepicker:any = $(this);
				_datepicker.parent().addClass('finalRow');

				$('.finalRow').prevAll().find('td:not(.ui-datepicker-unselectable)').addClass('highlight');
				_datepicker.prevAll('td:not(.ui-datepicker-unselectable)').addClass('highlight');

				if (_datepicker.parents().eq(3).hasClass('ui-datepicker-group-last')) {
					$('.ui-datepicker-group-first td:not(.ui-datepicker-unselectable)').addClass('highlight');
				}
			}
		});

		// Single trip calendar - one way trip
		_self.$instance.find('.oneWay-trip').datepicker({
			showButtonPanel: true,
			closeText      : '<i class="fa fa-times" aria-hidden="true"></i>',
			minDate        : $ibeTodayDate,
			dateFormat     : 'd M yy',
			maxDate        : $ibeMaxLimitDate,
			numberOfMonths : 2,
			firstDay: 1,
			beforeShow: function(ele:any, obj:any) {
				curInstance.find('#ui-datepicker-div').removeClass('multicityTrip');
				$curDatepickerInst = obj.dpDiv[0];
				$curDatepickerTitle = ele.dataset.datepickerTitle;
			},
			afterShow: function() {
				_self.bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
			}
		});

		// Multi city trip calendar
		if (window.location.search.indexOf('multicity=true') > -1) {
			$tripTypeContainer.find('.returnTrip').removeClass('selected');
			$tripTypeContainer.find('.multiCityTrip').addClass('selected');
			_self.$instance.find('.single-cityTrip--Container').hide();
			_self.$instance.find('.multi-cityTrip--Container').show();
		}

		let $multiCityDateFormat:any = 'd M yy';

		let $multiCityDestGroup = _self.$instance.find('.multi-city--destination-group');

		// initialize datepicker for each multicity date item
		$multiCityDestGroup.each(function(index:number, el:any) {
			let $dateInput = $(this).find('.dateDeparture');
			let $nextdateInput:any;

			if (index < $multiCityDestGroup.length) {
				$nextdateInput = $($multiCityDestGroup[index+1]).find('.dateDeparture');
			}

			$dateInput.datepicker({
				showButtonPanel: true,
				closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
				minDate: $ibeNowDate,
				dateFormat: 'd M yy',
				maxDate: $ibeMaxLimitDate,
				numberOfMonths: 2,
				firstDay: 1,
				beforeShow: function(ele:any, obj:any) {
					if (!curInstance.find('.multicityTrip').length) {
						curInstance.find('#ui-datepicker-div').addClass("multicityTrip");
					}
					$curDatepickerInst = obj.dpDiv[0];
					$curDatepickerTitle = ele.dataset.datepickerTitle;
				},
				afterShow: function() {
					_self.bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
				}
			}).on('change', (e:any) => {
				if ($nextdateInput.length) {
					$nextdateInput.datepicker('option', 'minDate', getMultiCityDate(e.target));
				}
			});
		});

		/**
		 * Parse multicity datepicker value from target element
		 */
		let getMultiCityDate:any = ($element: any) => {
			let $getMultiDate: any;
			try {
				// console.log($multiCityDateFormat, $element, $element.value);
				$getMultiDate = $.datepicker.parseDate($multiCityDateFormat, $element.value);
			} catch(error) {
				//console.error(error);
				$getMultiDate = null;
			}
			// console.log($getMultiDate);
			return $getMultiDate;
		}
	}

	/**
	 * @function passengerDetailsHotel
	 * Passenger details container
	 * !!! Properly scoped
	 */


	passengerDetailsHotel(): void {
		let _self = this;

		let $ticketAdultInput:number  = 1;
		let $ticketTeenagerInput:number  = 0;
		let $ticketChildInput:number  = 0;
		let $ticketInfantInput:number = 0;
		let $totalTickets:number      = 1;
		let $totalPassenger:any 	  = _self.$instance.find('.hotel-container .total-passengers');
		let curInstance = _self.$instance.find('.hotel-container'); // assign current instance to var as later requests will call latest assigned instance
		let $groupBooking = curInstance.find('.group-booking');
		let $isEnableNinePass: any	=	$('.hotel-container #isEnableNinePass');
		let $ticketAdultInput_roomf:number  = 1;
		let $ticketAdultInput_rooms:number  = 1;
		let $ticketAdultInput_roomt:number  = 1;
		let $ticketChildInput_roomf:number  = 0;
		let $ticketChildInput_rooms:number  = 0;
		let $ticketChildInput_roomt:number  = 0;
		let $ticketInfantInput_roomf:number  = 0;
		let $ticketInfantInput_rooms:number  = 0;
		let $ticketInfantInput_roomt:number  = 0;

		if (($isEnableNinePass.val()!='null') && ($isEnableNinePass.val()!='0') && ($isEnableNinePass.val()!='')) {
			$groupBooking.show();
		} else {
			$groupBooking.hide();
		}

		// let $ticketYouthInput:number  = 0;

		$totalPassenger.find('.hotel-container .total-nos').html($totalTickets);

		$('.hotel-container .close-bookingroomhotel2').on('click', () => {
			if($('#roomthre_hoteldetails').hasClass('hide'))
			{
				$('#roomtwo_hoteldetails').addClass('hide');
				$('.hotel-container .ticket-adult--input2').val('0');
				$('.hotel-container .ticket-infant--input2').val('0');
				$('.hotel-container .ticket-child--input2').val('0');
				$('#roomtwo_hoteldetails').find('.booking-ticket--nosr').remove();
				$('.hotel-container .close-bookingroomhotel2').addClass('hide');
				updateHotelTicketQtys();
			}
			$('.hotel-container .add_roomshotel').show();
		});
		$('.hotel-container .close-bookingroom_hotel3').on('click', () => {
			$('#roomthre_hoteldetails').addClass('hide');
			$('.hotel-container .add_roomshotel').show();
			$('.hotel-container .ticket-adult--input3').val('0');
			$('.hotel-container .ticket-infant--input3').val('0');
			$('.hotel-container .ticket-child--input3').val('0');
			$('#roomthre_hoteldetails').find('.booking-ticket--nosr').remove();
			$('.hotel-container .close-bookingroomhotel2').removeClass('hide');
			updateHotelTicketQtys();
		});

		$('.hotel-container .add_roomshotel').on('click', () => {
			if ($("#roomtwo_hoteldetails").hasClass('hide'))
			{
				$('#roomtwo_hoteldetails').removeClass('hide');
				$('.hotel-container .ticket-adult--input2').val('1');
				$('.hotel-container .close-bookingroomhotel2').removeClass('hide');
				curInstance.find('.booking-ticket--nos .age-label').show();
				updateHotelTicketQtys();
			}
			else
			{
				$('#roomthre_hoteldetails').removeClass('hide');
				curInstance.find('.booking-ticket--nos .age-label').show();
				$('.hotel-container .close-bookingroomhotel2').addClass('hide');
				$('.hotel-container .ticket-adult--input3').val('1');
				$('.hotel-container .add_roomshotel').hide();
				updateHotelTicketQtys();
			}
		});

		_self.$instance.find('.hotel-container .ticket-nos-btn').on('click', function(e:any) {
			e.preventDefault();

			// get currently acted on input field
			var fieldName  = $(this).attr('data-field'),
					type       = $(this).attr('data-type'),
					input      = curInstance.find("input[name='"+fieldName+"']"),
					currentVal = parseInt(input.val());

			// apply calculation to acted-on field (plus/minus)
			if (!isNaN(currentVal)) {
					input.data('oldValue', currentVal);
					if (type == 'minus') {
							if (currentVal > parseInt(input.attr('min'))) {
									input.val(currentVal - 1);
									input.trigger('change');
							}
							if (parseInt(input.val()) == parseInt(input.attr('min'))) {
									$(this).attr('disabled', true);
							}
					} else if (type == 'plus') {
							if (currentVal < input.attr('max')) {
									input.val(currentVal + 1);
									input.trigger('change');
							}
							if (parseInt(input.val()) == input.attr('max')) {
									$(this).attr('disabled', true);
							}
					}
			} else {
					input.val(0);
			}

			// updateHotelTicketQtys();
			if (!isNaN(currentVal) && fieldName=="passengersChildren" ||fieldName=="passengersChildren2"||fieldName=="passengersChildren3") {
				// show age box if hide
				let room_var=fieldName;
				var currentChild = currentVal+1;
				var currentChildmnus = currentVal-1;
				//flight-container
				$('.hotel-container .child-age-grp'+room_var).show();
				//$('.flight-container .child-age-grp').show();
				if (type == 'minus') {
					if(currentChildmnus%8 ==0){
						$( ".hotel-container #child-age-col"+room_var+currentChildmnus ).remove();
						//$( ".flight-container #child-age-col"+currentChildmnus ).remove();
					}else{
						//Append box
						$('.hotel-container #child-age-select'+room_var+currentVal).empty();
						//$('.flight-container #child-age-select'+currentVal).empty();
					}
				} else if (type == 'plus') {
					if(currentVal%8 ==0){
						// Append column
						let ageLabel ='';
						let errorChildAge ='';
						if(currentChild == 1){
							ageLabel ='Age';
							errorChildAge ='<div class="child-age-error" data-childage-limit="Child/Teenager age must be between 2 and 17" data-childage="Child/Teenager age is missing" style="display: none;">Please enter child/teenager age</div>';
						}
						var col1 =currentChild;
						var col2 =currentChild+1;
						var col3 =currentChild+2;
						var col4 =currentChild+3;
						var col5 =currentChild+4;
						var col6 =currentChild+5;
						var col7 =currentChild+6;
						var col8 =currentChild+7;
						var col9 =currentChild+9
						let $childAgeList ='<div class="col-lg-12 col-md-12 col-sm-12 booking-person" id="child-age-col'+room_var+currentVal+'">'
						+'<div class="col-lg-12 col-md-12 col-sm-12 booking-ticket--nosr adult-nos"><div class="age-label">Age of Children/Teenager</div>'
						+ errorChildAge
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col1+'">'
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col2+'"> '
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col3+'">'
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col4+'">'
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col5+'"> '
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col6+'">'
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col7+'"> '
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col8+'">'
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col9+'">'
						+'	</div>'
						+'</div>'
						+' </div>'
						
						// $('.flight-container #child-age-grp').append($childAgeList);	
						// $('.flight-container #child-age-select'+currentChild).append('<div class="col-lg-6 col-md-6 col-sm-6"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						// +'<div class="col-lg-6 col-md-6 col-sm-6 childAgeInputSelect"><select id="childAgeInput'+currentChild+'" name=""><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
						$('.hotel-container #child-age-grp'+room_var).append($childAgeList);	
						$('.hotel-container #child-age-select'+room_var+currentChild).append('<div class="col-lg-6 col-md-6 col-sm-6"><label class="booking-form--title1" for="childCount"> Child/Teenager '+currentChild+'</label></div>'
						+'<div class="col-lg-6 col-md-6 col-sm-6 childAgeInputSelect"><select id="childAgeInput'+currentChild+'" name=""><option value="2" "selected">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');

					}else{
						//Append box
						// $('.flight-container #child-age-select'+currentChild).append('<div class="col-lg-6 col-md-6 col-sm-6"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						// +'<div class="col-lg-6 col-md-6 col-sm-6 childAgeInputSelect"><select id="childAgeInput'+currentChild+'" name=""><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
						$('.hotel-container #child-age-select'+room_var+currentChild).append('<div class="col-lg-6 col-md-6 col-sm-6"><label class="booking-form--title1" for="childCount"> Child//Teenager '+currentChild+'</label></div>'
						+'<div class="col-lg-6 col-md-6 col-sm-6 childAgeInputSelect"><select id="childAgeInput'+currentChild+'" name=""><option value="2" "selected">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');

					}
				}
				else{
					$('.flight-container #child-age-select'+room_var+currentChild).append('');
				}
		}
		});

		//Incude child age select box

		// disable user input on field (next statement will no longer have any effect)
		_self.$instance.find('.hotel-container .minus-plus-input').attr('readonly', true);

		// store current value of input to data-attribute on focus
		// in case user manually edits fields
		_self.$instance.find('.hotel-container .minus-plus-input').on('focusin', function() {
			 $(this).data('oldValue', $(this).val());
		});

		// on value increment/decrement, update old value data-attribute
		_self.$instance.find('.hotel-container .minus-plus-input').on('change', function() {
			let minValue     = parseInt($(this).attr('min'));
			let maxValue     = parseInt($(this).attr('max'));
			let valueCurrent = parseInt($(this).val());
			let name         = $(this).attr('name');

			if (valueCurrent >= minValue) {
				curInstance.find(".ticket-nos-btn[data-type='minus'][data-field='"+name+"']").removeAttr('disabled');
			} else {
				$(this).data('oldValue',$(this).val());
			}

			if (valueCurrent <= maxValue) {
				curInstance.find(".ticket-nos-btn[data-type='plus'][data-field='"+name+"']").removeAttr('disabled');
			} else {
				$(this).data('oldValue',$(this).val());
			}
			updateHotelTicketQtys();
		});

		// prevent input to passenger number field by keyboard
		// only allow change from pressing buttons
		_self.$instance.find('.hotel-container .minus-plus-input').on('keydown', function (e:any) {
			if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
				(e.keyCode == 65 && e.ctrlKey === true) ||
				(e.keyCode >= 35 && e.keyCode <= 39)) {
				return;
			}
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});

		// run once on ready
		// _self.$instance.find('.minus-plus-input').trigger('change');
		updateHotelTicketQtys();

		/**
		 * calculate total ticket amount based on current values and populate display fields
		 * @return void
		 */
		function updateHotelTicketQtys() {
			let $passengerDetailsActive = curInstance.find('[data-booking-passenger-details-selected]');

			$ticketAdultInput_roomf = parseInt($('.hotel-container .ticket-adult--input1').val());
			$ticketAdultInput_rooms = parseInt($('.hotel-container .ticket-adult--input2').val());
			$ticketAdultInput_roomt = parseInt($('.hotel-container .ticket-adult--input3').val());
			$ticketChildInput_roomf = parseInt($('.hotel-container .ticket-child--input').val());
			$ticketChildInput_rooms = parseInt($('.hotel-container .ticket-child--input2').val());
			$ticketChildInput_roomt = parseInt($('.hotel-container .ticket-child--input3').val());
			$ticketInfantInput_roomf = parseInt($('.hotel-container .ticket-infant--input').val());
			$ticketInfantInput_rooms = parseInt($('.hotel-container .ticket-infant--input2').val());
			$ticketInfantInput_roomt = parseInt($('.hotel-container .ticket-infant--input3').val());		
			// get current values in input field and assign to method vars
			$ticketAdultInput = $ticketAdultInput_roomf +$ticketAdultInput_rooms + $ticketAdultInput_roomt;
			$ticketInfantInput = $ticketInfantInput_roomf +$ticketInfantInput_rooms + $ticketInfantInput_roomt;
			$ticketChildInput = $ticketChildInput_roomf +$ticketChildInput_rooms + $ticketChildInput_roomt;


			// only adult, teenager and child tickets count towards limit
			$totalTickets = $ticketAdultInput + $ticketInfantInput + $ticketChildInput;
			// get current values in input field and assign to method vars
			// $ticketAdultInput = parseInt($passengerDetailsActive.find('.ticket-adult--input').val());
			// $ticketTeenagerInput = _self.isUkCitySelectedForIbeSearch ? parseInt($passengerDetailsActive.find('.ticket-teenager--input').val()) : 0;
			// $ticketChildInput = parseInt($passengerDetailsActive.find('.ticket-child--input').val());
			// //$ticketInfantInput = parseInt($passengerDetailsActive.find('.ticket-infant--input').val());

			// only adult, teenager and child tickets count towards limit
			// $totalTickets = $ticketAdultInput + (_self.isUkCitySelectedForIbeSearch ? $ticketTeenagerInput : 0) + $ticketChildInput;
			let $totalPassengersVal:any = $totalTickets;
			let $totalPassenger:any 	  = curInstance.find('.total-passengers');

			// update hidden input value for total tickets added
			// update display text for total tickets added
			_self.$instance.find('.hotel-container .total-tickets--value').val($totalTickets);
			$totalPassenger.find('.total-nos').html($totalPassengersVal);
			//let $totalPassengerDisplay:any 	  = curInstance.find('.flight-container .total-passengers');
			let $totalTravelerDisplay:any 	  = curInstance.find('.total-passengers');
			if ($totalTickets >= 2) {
				//$totalPassengerDisplay.find('.type').html('Passengers');
				$totalTravelerDisplay.find('.type').html('Travellers');
			} else {
				//$totalPassengerDisplay.find('.type').html('Passenger');
				$totalTravelerDisplay.find('.type').html('Traveller');
			}

			// infant validations

			if($ticketInfantInput==3)
			{
				curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', true);
			}
			else
			{
					if ($ticketAdultInput_roomf == $ticketInfantInput_roomf) 
					{
						$('#roomone_hoteldetails').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
					} 
					else if ($ticketAdultInput_roomf <$ticketInfantInput_roomf)
					{
						$('#roomone_hoteldetails').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
						$('#roomone_hoteldetails').find('.ticket-infant--input').val($ticketAdultInput_roomf);
					}
					else
					{
						$('#roomone_hoteldetails').find('.infant-nos .input-group--btn .plus').attr('disabled', false);
					}

					if ($ticketAdultInput_rooms == $ticketInfantInput_rooms) 
					{
						$('#roomtwo_hoteldetails').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
					} 
					else if ($ticketAdultInput_rooms <$ticketInfantInput_rooms)
					{
						$('#roomtwo_hoteldetails').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
						$('#roomtwo_hoteldetails').find('.ticket-infant--input').val($ticketAdultInput_rooms);
					}
					else
					{
						$('#roomtwo_hoteldetails').find('.infant-nos .input-group--btn .plus').attr('disabled', false);
					}


					if ($ticketAdultInput_roomt == $ticketInfantInput_roomt) 
					{
						$('#roomthre_hoteldetails').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
					} 
					else if ($ticketAdultInput_roomt <$ticketInfantInput_roomt)
					{
						$('#roomthre_hoteldetails').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
						$('#roomthre_hoteldetails').find('.ticket-infant--input').val($ticketAdultInput_roomt);
					}
					else
					{
						$('#roomthre_hoteldetails').find('.infant-nos .input-group--btn .plus').attr('disabled', false);
					}
				}
				
				// adult validations

				let $totalTickets_room1:number = $ticketAdultInput_roomf  + $ticketChildInput_roomf;
				let $totalTickets_room2:number = $ticketAdultInput_rooms  + $ticketChildInput_rooms;
				let $totalTickets_room3:number = $ticketAdultInput_roomt  + $ticketChildInput_roomt;

				if($totalTickets_room1==9)
				{
				$('#roomone_hoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				$('#roomone_hoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', true);
				}
				else
				{
				$('#roomone_hoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				$('#roomone_hoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', false);
				}
				 if($totalTickets_room2==9)
				{
					$('#roomtwo_hoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
					$('#roomtwo_hoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', true);
				}

				else
				{
					$('#roomtwo_hoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
					$('#roomtwo_hoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', false);
				}
				if($totalTickets_room3==9)
				{
					$('#roomthre_hoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
					$('#roomthre_hoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', true);
				}
				else
				{
					$('#roomthre_hoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
					$('#roomthre_hoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', false);
				}

		}
	}

	/**
	 * @function passengerDetailsFlightHotel
	 * Passenger details container
	 * !!! Properly scoped
	 */

	passengerDetailsFlightHotel(): void {
		let _self = this;

		let $ticketAdultInput_roomf:number  = 1;
		let $ticketAdultInput_rooms:number  = 1;
		let $ticketAdultInput_roomt:number  = 1;
		let $ticketChildInput_roomf:number  = 0;
		let $ticketChildInput_rooms:number  = 0;
		let $ticketChildInput_roomt:number  = 0;
		let $ticketInfantInput_roomf:number  = 0;
		let $ticketInfantInput_rooms:number  = 0;
		let $ticketInfantInput_roomt:number  = 0;

		let $ticketAdultInput:number  = 1;
		let $ticketTeenagerInput:number  = 0;
		let $ticketChildInput:number  = 0;
		let $ticketInfantInput:number = 0;
		let $totalTickets:number      = 1;
		let $totalPassenger:any 	  = _self.$instance.find('.flight-container .total-passengers');
		let curInstance = _self.$instance.find('.flight-container'); // assign current instance to var as later requests will call latest assigned instance
		let $groupBooking = curInstance.find('.group-booking');
		let $isEnableNinePass: any	=	$('.flight-container #isEnableNinePass');
 
		if (($isEnableNinePass.val()!='null') && ($isEnableNinePass.val()!='0') && ($isEnableNinePass.val()!='')) {
			$groupBooking.show();
		} else {
			$groupBooking.hide();
		}

		// let $ticketYouthInput:number  = 0;

		$totalPassenger.find('.flight-container .total-nos').html($totalTickets);
		$('.flight-container .close-bookingroom2').on('click', () => {
			if($('#roomthre_details').hasClass('hide'))
			{
				$('#roomtwo_details').addClass('hide');
				$('.flight-container .ticket-adult--input2').val('0');
				$('.flight-container .ticket-infant--input2').val('0');
				$('.flight-container .ticket-child--input2').val('0');
				$('#roomtwo_details').find('.booking-ticket--nosr').remove();
				$('.flight-container .close-bookingroom2').addClass('hide');
				updateTicketQtys();
			}
			$('.add_rooms').show();
		});
		$('.flight-container .close-bookingroom3').on('click', () => {
			$('#roomthre_details').addClass('hide');
			$('.flight-container .add_rooms').show();
			$('.flight-container .ticket-adult--input3').val('0');
			$('.flight-container .ticket-infant--input3').val('0');
			$('.flight-container .ticket-child--input3').val('0');
			$('#roomthre_details').find('.booking-ticket--nosr').remove();
			$('.flight-container .close-bookingroom2').removeClass('hide');
			updateTicketQtys();
		});

		$('.flight-container .add_rooms').on('click', () => {
			if ($("#roomtwo_details").hasClass('hide'))
			{
				$('#roomtwo_details').removeClass('hide');
				$('.flight-container .ticket-adult--input2').val('1');
				$('.flight-container .close-bookingroom2').removeClass('hide');
				curInstance.find('.booking-ticket--nos .age-label').show();
				updateTicketQtys();
			}
			else
			{
				$('#roomthre_details').removeClass('hide');
				curInstance.find('.booking-ticket--nos .age-label').show();
				$('.close-bookingroom2').addClass('hide');
				$('.ticket-adult--input3').val('1');
				$('.add_rooms').hide();
				updateTicketQtys();
			}

		});

		_self.$instance.find('.flight-container .ticket-nos-btn').on('click', function(e:any) {
			e.preventDefault();

			// get currently acted on input field
			var fieldName  = $(this).attr('data-field'),
					type       = $(this).attr('data-type'),
					input      = curInstance.find("input[name='"+fieldName+"']"),
					currentVal = parseInt(input.val());

			// apply calculation to acted-on field (plus/minus)
			if (!isNaN(currentVal)) {
					input.data('oldValue', currentVal);
					if (type == 'minus') {
							if (currentVal > parseInt(input.attr('min'))) {
									input.val(currentVal - 1);
									input.trigger('change');
							}
							if (parseInt(input.val()) == parseInt(input.attr('min'))) {
									$(this).attr('disabled', true);
							}
					} else if (type == 'plus') {
							if (currentVal < input.attr('max')) {
									input.val(currentVal + 1);
									input.trigger('change');
							}
							if (parseInt(input.val()) == input.attr('max')) {
									$(this).attr('disabled', true);
							}
					}
			} else {
					input.val(0);
			}

			// updateTicketQtys();
			if (!isNaN(currentVal) && (fieldName=="passengersChildren" ||fieldName=="passengersChildren2"||fieldName=="passengersChildren3") ) {
				// show age box if hide
				let room_var=fieldName;
				var currentChild = currentVal+1;
				var currentChildmnus = currentVal-1;
				//flight-container
				$('.flight-container .child-age-grp+'+room_var).show();
				//$('.flight-container .child-age-grp').show();
				if (type == 'minus') {
					if(currentChildmnus%8 ==0){
						$( ".flight-container #child-age-col"+room_var+currentChildmnus ).remove();
						//$( ".flight-container #child-age-col"+currentChildmnus ).remove();
					}else{
						//Append box
						$('.flight-container #child-age-select'+room_var+currentVal).empty();
						//$('.flight-container #child-age-select'+currentVal).empty();
					}
				} else if (type == 'plus') {
					if(currentVal%8 ==0){
						// Append column
						let ageLabel ='';
						let errorChildAge ='';
						if(currentChild == 1){
							ageLabel ='Age';
							errorChildAge ='<div class="child-age-error" data-childage-limit="Child/Teenager age must be between 2 and 17" data-childage="Child/Teenager age is missing" style="display: none;">Please enter child/teenager age</div>';
						}
						var col1 =currentChild;
						var col2 =currentChild+1;
						var col3 =currentChild+2;
						var col4 =currentChild+3;
						var col5 =currentChild+4;
						var col6 =currentChild+5;
						var col7 =currentChild+6;
						var col8 =currentChild+7;
						var col9 =currentChild+9
						let $childAgeList ='<div class="col-lg-12 col-md-12 col-sm-12 booking-person" id="child-age-col'+room_var+currentVal+'">'
						+'<div class="col-lg-12 col-md-12 col-sm-12 booking-ticket--nosr adult-nos"><div class="age-label">Age of Children/Teenager</div>'
						+ errorChildAge
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col1+'">'
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col2+'"> '
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col3+'">'
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col4+'">'
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col5+'"> '
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col6+'">'
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col7+'"> '
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col8+'">'
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col9+'">'
						+'	</div>'
						+'</div>'
						+' </div>'
						
						// $('.flight-container #child-age-grp').append($childAgeList);	
						// $('.flight-container #child-age-select'+currentChild).append('<div class="col-lg-6 col-md-6 col-sm-6"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						// +'<div class="col-lg-6 col-md-6 col-sm-6 childAgeInputSelect"><select id="childAgeInput'+currentChild+'" name=""><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
						$('.flight-container #child-age-grp'+room_var).append($childAgeList);	
						$('.flight-container #child-age-select'+room_var+currentChild).append('<div class="col-lg-6 col-md-6 col-sm-6"><label class="booking-form--title1" for="childCount"> Child/Teenager '+currentChild+'</label></div>'
						+'<div class="col-lg-6 col-md-6 col-sm-6 childAgeInputSelect"><select id="childAgeInput'+currentChild+'" name=""><option value="2" "selected">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');

					}else{
						//Append box
						// $('.flight-container #child-age-select'+currentChild).append('<div class="col-lg-6 col-md-6 col-sm-6"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						// +'<div class="col-lg-6 col-md-6 col-sm-6 childAgeInputSelect"><select id="childAgeInput'+currentChild+'" name=""><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
						$('.flight-container #child-age-select'+room_var+currentChild).append('<div class="col-lg-6 col-md-6 col-sm-6"><label class="booking-form--title1" for="childCount"> Child/Teenager '+currentChild+'</label></div>'
						+'<div class="col-lg-6 col-md-6 col-sm-6 childAgeInputSelect"><select id="childAgeInput'+currentChild+'" name=""><option value="2" "selected">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');

					}
				}
				else{
					$('.flight-container #child-age-select'+room_var+currentChild).append('');
				}
		}
		});

		//Incude child age select box

		// disable user input on field (next statement will no longer have any effect)
		_self.$instance.find('.flight-container .minus-plus-input').attr('readonly', true);

		// store current value of input to data-attribute on focus
		// in case user manually edits fields
		_self.$instance.find('.flight-container .minus-plus-input').on('focusin', function() {
			 $(this).data('oldValue', $(this).val());
		});

		// on value increment/decrement, update old value data-attribute
		_self.$instance.find('.flight-container .minus-plus-input').on('change', function() {
			let minValue     = parseInt($(this).attr('min'));
			let maxValue     = parseInt($(this).attr('max'));
			let valueCurrent = parseInt($(this).val());
			let name         = $(this).attr('name');

			if (valueCurrent >= minValue) {
				curInstance.find(".ticket-nos-btn[data-type='minus'][data-field='"+name+"']").removeAttr('disabled');
			} else {
				$(this).data('oldValue',$(this).val());
			}

			if (valueCurrent <= maxValue) {
				curInstance.find(".ticket-nos-btn[data-type='plus'][data-field='"+name+"']").removeAttr('disabled');
			} else {
				$(this).data('oldValue',$(this).val());
			}
			updateTicketQtys();
		});

		// prevent input to passenger number field by keyboard
		// only allow change from pressing buttons
		_self.$instance.find('.flight-container .minus-plus-input').on('keydown', function (e:any) {
			if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
				(e.keyCode == 65 && e.ctrlKey === true) ||
				(e.keyCode >= 35 && e.keyCode <= 39)) {
				return;
			}
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});

		// run once on ready
		// _self.$instance.find('.minus-plus-input').trigger('change');
		updateTicketQtys();

		/**
		 * calculate total ticket amount based on current values and populate display fields
		 * @return void
		 */
		function updateTicketQtys() {
			let $passengerDetailsActive = curInstance.find('[data-booking-passenger-details-selected]');
			// get current values in input field and assign to method vars
			$ticketAdultInput_roomf = parseInt($('.flight-container .ticket-adult--input1').val());
			$ticketAdultInput_rooms = parseInt($('.flight-container .ticket-adult--input2').val());
			$ticketAdultInput_roomt = parseInt($('.flight-container .ticket-adult--input3').val());
			$ticketChildInput_roomf = parseInt($('.flight-container .ticket-child--input').val());
			$ticketChildInput_rooms = parseInt($('.flight-container .ticket-child--input2').val());
			$ticketChildInput_roomt = parseInt($('.flight-container .ticket-child--input3').val());
			$ticketInfantInput_roomf = parseInt($('.flight-container .ticket-infant--input').val());
			$ticketInfantInput_rooms = parseInt($('.flight-container .ticket-infant--input2').val());
			$ticketInfantInput_roomt = parseInt($('.flight-container .ticket-infant--input3').val());		
			// get current values in input field and assign to method vars
			$ticketAdultInput = $ticketAdultInput_roomf +$ticketAdultInput_rooms + $ticketAdultInput_roomt;
			$ticketInfantInput = $ticketInfantInput_roomf +$ticketInfantInput_rooms + $ticketInfantInput_roomt;
			$ticketChildInput = $ticketChildInput_roomf +$ticketChildInput_rooms + $ticketChildInput_roomt;

			// $ticketTeenagerInput = _self.isUkCitySelectedForIbeSearch ? parseInt($passengerDetailsActive.find('.ticket-teenager--input').val()) : 0;
			// $ticketChildInput = parseInt($passengerDetailsActive.find('.ticket-child--input').val());
			//$ticketInfantInput = parseInt($passengerDetailsActive.find('.ticket-infant--input').val());

			// only adult, teenager and child tickets count towards limit
			$totalTickets = $ticketAdultInput + $ticketInfantInput + $ticketChildInput;
			let $totalPassengersVal: any = $totalTickets;
			let $totalPassenger: any = curInstance.find('.total-passengers');

			// update hidden input value for total tickets added
			// update display text for total tickets added
			_self.$instance.find('.flight-container .total-tickets--value').val($totalTickets);
			$totalPassenger.find('.total-nos').html($totalPassengersVal);
			let $totalPassengerDisplay: any = curInstance.find('.total-passengers');
			//let $totalTravelerDisplay:any 	  = curInstance.find('.total-passengers');
			if ($totalTickets >= 2) {
				$totalPassengerDisplay.find('.type').html('Travellers');
			} else {
				$totalPassengerDisplay.find('.type').html('Traveller');
			}

			// infant same should be same or below adult count for room1

			if($ticketInfantInput==3)
			{
				curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', true);
			}
			else
			{

					if ($ticketAdultInput_roomf == $ticketInfantInput_roomf) 
					{
						$('#roomone_details').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
					} 
					else if ($ticketAdultInput_roomf <$ticketInfantInput_roomf)
					{
						$('#roomone_details').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
						$('#roomone_details').find('.ticket-infant--input').val($ticketAdultInput_roomf);
					}
					else
					{
						$('#roomone_details').find('.infant-nos .input-group--btn .plus').attr('disabled', false);
					}


					if ($ticketAdultInput_rooms == $ticketInfantInput_rooms) 
					{
						$('#roomtwo_details').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
					} 
					else if ($ticketAdultInput_rooms <$ticketInfantInput_rooms)
					{
						$('#roomtwo_details').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
						$('#roomtwo_details').find('.ticket-infant--input').val($ticketAdultInput_rooms);
					}
					else
					{
						$('#roomtwo_details').find('.infant-nos .input-group--btn .plus').attr('disabled', false);
					}


					if ($ticketAdultInput_roomt == $ticketInfantInput_roomt) 
					{
						$('#roomthre_details').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
					} 
					else if ($ticketAdultInput_roomt <$ticketInfantInput_roomt)
					{
						$('#roomthre_details').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
						$('#roomthre_details').find('.ticket-infant--input').val($ticketAdultInput_roomt);
					}
					else
					{
						$('#roomthre_details').find('.infant-nos .input-group--btn .plus').attr('disabled', false);
					}
				}
			let $totalPassengersValnew: any =$ticketAdultInput  + $ticketChildInput;
			if ($totalPassengersValnew >= 9 ) {
				curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.flight-container .add_rooms').css({ 'opacity': '0.5','pointer-events': 'none' });
				// curInstance.find('.youth-nos .input-group--btn .plus').attr('disabled', true);
				// curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', true);
			} else {
				curInstance.find('.flight-container .add_rooms').css({ 'opacity': '1','pointer-events': 'auto' });
				if ($ticketAdultInput >= 9) {
					curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				} else {
					curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				}
				curInstance.find('.teenager-nos .input-group--btn .plus').attr('disabled', false);
				if ($ticketChildInput >= 6) {
					curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', true);
				}
				else {
					curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', false);
				}
				// curInstance.find('.youth-nos .input-group--btn .plus').attr('disabled', false);
				// curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', false);
			}
		}
	}


	/**
	 * create validation list container for desktop booking form
	 */
	createDesktopErrorValidationList(): void {
		let _self = this;

		if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )) {
			_self.$instance.find('.validation-content').append('<ul class="validation--error-list"></ul>');
		}
	}

	/**
	 * @function ibeSingleFormSubmitHandler
	 * !!! Properly scoped
	 */
	ibeSingleFormSubmitHandler(): void {
		let _self = this;

		let $errorValidation = _self.$instance.find('.error-validation').first();
		let $singleTripSubmitBtn:any    = _self.$instance.find('.mholidays-single-city--bookflight');
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance
		let $hotelSubmitBtn:any    = _self.$instance.find('.mholidays-book-hotel');

		//if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )) {
			_self.getOfficeCode();

			$singleTripSubmitBtn.on('click', (evt:any) => {
				this.$error = [];
				evt.preventDefault();
				adobeDataLayer.push('click', {
					'clickName': 'click:btn-click:flight-and-hotel-search',
					'componentType': 'btn',
					'componentName': 'Flight And Hotel',
					'componentID': '',
					'attributes': []
				});
				let ieversion = new headerContent();
				ieversion.checkIEVersion_disablePupup();
				$errorValidation.show();
				_self.bookingFormSubmit.mholidaysingleBookingFormValidation(curInstance, _self.$officeCode, function($officeCode:any){
						_self.bookingFormSubmit.mholidaysDeeplinknew(curInstance);

				});
			});
			$hotelSubmitBtn.on('click', (evt:any) => {
				this.$error = [];
				evt.preventDefault();
				let ieversion = new headerContent();
				ieversion.checkIEVersion_disablePupup();		
				$errorValidation.show();
				_self.bookingFormSubmit.mholidaysHotelFormValidation(curInstance, _self.$officeCode, function($officeCode:any){
						_self.bookingFormSubmit.mholidaysHotelDeeplink(curInstance);

				});

			});

		//}
	}

	/**
	 * @function getOfficeCode
	 * !!! Properly scoped
	 */
	getOfficeCode():void {
		let _self:any = this;

		let setOfficeID:any = ($fromOfficeID:string) => {
			_self.$officeCode = $fromOfficeID;
		}

		_self.$instance.find('.fromLocation').off('change.officecode').on('change.officecode', function(e:any) {
			let $pickerID = e.target.id;
			let $selected = $(this).find(":selected");
			// let $selected_value = $selected.val();
			let $selected_text = $selected.text();
			// let $fromOfficeID = $(this).parent().find('.selectize-dropdown-content .option.selected').parent().attr('data-group');
			let $fromOfficeID = $selected_text.substring($selected_text.lastIndexOf(",")+1,$selected_text.indexOf("(")).replace(/\s+/g,"");
			setOfficeID($fromOfficeID);
		});

		_self.$instance.find('[name="multiCityfromLocation1"]').off('change.officecode').on('change.officecode', function(e:any) {
			let $pickerID = e.target.id;
			let $selected = $(this).find(":selected");
			// let $selected_value = $selected.val();
			let $selected_text = $selected.text();
			// let $fromOfficeID = $(this).parent().find('.selectize-dropdown-content .option.selected').parent().attr('data-group');
			let $fromOfficeID = $selected_text.substring($selected_text.lastIndexOf(",") + 1, $selected_text.indexOf("(")).replace(/\s+/g,"");
			setOfficeID($fromOfficeID);
		});
	}

	/**
	 * expand this instance of ibe
	 * extrapolate method so that it can be used elsewhere
	 * instead of just selectize.focus()
	 * @author dominic <dominic.gan@mirumagency.com>
	 */
	expandIbe(instance:any):void {
		let $searchContainer = instance.find('.search-container');
		let $tripTypeContainer = instance.find('.trip-container');
		let $paymentTypeContainer = instance.find('.payment-type-container');
		let $recentContainer = instance.find('.recent-container');
		let $closeBtn = instance.find('.close-container');

		$searchContainer.show();
		$searchContainer.parent().addClass('expanded');
		$tripTypeContainer.show();
		$paymentTypeContainer.show();
		$recentContainer.show();
		$closeBtn.find('.close-booking').addClass('expanded');
	}

	/**
	 * @function initSelectize
	 * ibe from location event handlers
	 * @param  {any} listItems [description]
	 * @return {any}           [description]
	 * !!! Properly scoped
	 */
	initSelectize(listItems:any):void {
		let _self = this;

		let $ibeFromLocation:any     = _self.$instance.find('.mholidays-ibe-from--location');
		let $ibeFromBookingTitle:any = _self.$instance.find('.fromLocation .booking-form--title');
		let $ibeFromSelectize:any;

		let $ibeToLocation:any     = _self.$instance.find('.mholidays-ibe-to--location');
		let $ibeToLocationById:any     = _self.$instance.find('#mholidaysibeToLocation');
		let $returnTripDateSelectorById:any     = _self.$instance.find('#returnTripDateSelector');
		let $oneWayTripDateSelectorById:any     = _self.$instance.find('#oneWayTripDateSelector');
		let $ibeToBookingTitle:any = _self.$instance.find('.toLocation .booking-form--title');
		let $ibeToSelectize:any;
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance
		let $recentHide:any =false;
		let $cugParam:any = $('#search-param-cug').val();
		let $studentPortalDashboard:boolean =false;
		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');
		if(studentEnrichIdCookieVal != null && studentDashboard != null){
			$studentPortalDashboard  = true;
		}
		// UK city list
		let ukCities:any = [];

		// To check ibe widget is clicked
		let $ibeClickFlag:boolean =false;
		// let singleFromSelectizeReady:any = $.Deferred();
		// let singleToSelectizeReady:any = $.Deferred();

		$ibeFromLocation.html(listItems);
		  	/**
				 * [getCookieByMatch description]
				 * @param {string} regex [description]
				 */
				function getCookieByMatch(regex:RegExp) {
				let cs:any = document.cookie.split(/;\s*/),
						ret:Array<any> = [];
				for (var i:number = 0; i < cs.length; i++) {
					if (cs[i].match(regex)) {
						ret.push(cs[i]);
					}
				}
				return ret ;
			}
		$ibeFromLocation.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($ibeFromLocation[0].selectize);
				$ibeFromSelectize = $($ibeFromLocation[0].selectize.$control[0]);

				// singleFromSelectizeReady.resolve();
			},
			onFocus: function() {
				_self.expandIbe(curInstance);

				$ibeFromBookingTitle.addClass('input-filled');
				$ibeFromBookingTitle.removeClass('has-error');
				$ibeFromSelectize.addClass('select-filled');
				$ibeFromSelectize.removeClass('has-error');
				let $fromLocationChange = $ibeFromLocation.find('option:selected').text();
				let recentSearchCookieArr = getCookieByMatch(/^recent-search-cookie-\d+=/);

				if (recentSearchCookieArr.length > 0 && $cugParam !="CUG" && $studentPortalDashboard == false) {
					$(".fromLocation .selectize-dropdown .selectize-dropdown-content").show();
				}
				
			},

			onChange: function(value:any) {
				$ibeFromBookingTitle.addClass('input-filled');
				$ibeFromSelectize.addClass('select-filled');

				/* Handling passenger type for uk cities */
				if (ukCities.includes(value) || ukCities.includes($ibeToLocation.val())) {
					$('.passenger-details-selected .teenager-cat').css('display', 'block');
					$('.passenger-details-selected .is-uk').css('display', 'block');
					$('.passenger-details-selected .isnt-uk').css('display', 'none');
					_self.isUkCitySelectedForIbeSearch = true;
				} else {
					$('.passenger-details-selected .isnt-uk').css('display', 'block');
					$('.passenger-details-selected .teenager-cat').css('display', 'none');
					$('.passenger-details-selected .is-uk').css('display', 'none');
					_self.isUkCitySelectedForIbeSearch = false;
					_self.$instance.find('.passenger-details-selected .ticket-teenager--input').val(0).trigger('change');
				}

				if ($ibeFromLocation.val() === $ibeToLocation.val()) {
					if ($ibeToLocation.val() !== '') {
						$ibeToSelectize.addClass('has-error');
						$ibeToBookingTitle.addClass('has-error');
					}
				}
				else {
					let ibeFromLocationVal = $ibeFromLocation.val().trim();
					let cashFlowType = _self.$instance.find('input[name="cash_miles_type"]:checked').val();

					// let ibeToLocationPrepop = $ibeToLocation.attr('data-prepop-value');

					if (_self.toCityFromCookie) {
						_self.toCityFromCookie = undefined;
					}
					_self.bcommon.updateMholidaysOnDListOnFlowChange("mholiday", ibeFromLocationVal, $ibeToLocation);
		
						// }
					$ibeToSelectize.removeClass('has-error');
					$ibeToBookingTitle.removeClass('has-error');
					if (ibeFromLocationVal != "" && !_self.recentSearchActive) {
						setTimeout(function() {
							$ibeToLocationById.find('input[type="select-one"]').focus();
							$ibeToBookingTitle.addClass('input-filled');
							$ibeToSelectize.addClass('select-filled');
						}, 300);
					}
				}
			},
			onBlur: function(data:any) {
				let $fromLocationChange = $ibeFromLocation.find('option:selected').text();
				if($recentHide == false){
				$('.evo-autocomplete--static').hide(); 
				}
				if ($fromLocationChange == '') {
					$ibeFromBookingTitle.removeClass('input-filled');
					$ibeFromSelectize.removeClass('select-filled');
				} else {
					$ibeFromBookingTitle.addClass('input-filled');
					$ibeFromSelectize.addClass('select-filled');
				}
				$recentHide = false;
			},
			
			onLoad: function(data:any) {
				$ibeFromLocation[0].selectize.trigger('blur');
			},
			lockOptgroupOrder: true,
			searchField      : ['text', 'optgroup'],
			selectOnTab      : true
		});
		
		$(".mholidays-ibe-from--location").keydown(function(event: any) {
			if (event.keyCode === 9) {
				event.preventDefault();
				event.stopPropagation();
			}
		});

		$('.evo-autocomplete--static').mousedown(function(e:any) {
			$recentHide = true;
			$('.evo-autocomplete--static').show(); 
		   });
		
		$(".mholidays-ibe-from--location .selectize-input input").keyup(function(){ 
			//let $fromLocationChange = $ibeFromLocation.find('option:selected').text();
			let recentSearchCookieArr = getCookieByMatch(/^recent-search-cookie-\d+=/);

			if (recentSearchCookieArr.length > 0 && $cugParam!= "CUG" && $studentPortalDashboard == false) {
				if ($(".mholidays-ibe-from--location .selectize-input input").val() == '') {
					//$('.evo-autocomplete--static').show();
					$(".fromLocation .selectize-dropdown .selectize-dropdown-content").show();
				}else{
					$('.evo-autocomplete--static').hide();
					$(".fromLocation .selectize-dropdown .selectize-dropdown-content").show();
				}
			}
		});
		
		// singleFromSelectizeReady.promise();

		$ibeToLocation.html(listItems);
		$ibeToLocation.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($ibeToLocation[0].selectize);
				$ibeToSelectize = $($ibeToLocation[0].selectize.$control[0]);

				// singleToSelectizeReady.resolve();
			},
			onFocus: function() {
				_self.expandIbe(curInstance);

				$ibeToBookingTitle.addClass('input-filled');
				$ibeToBookingTitle.removeClass('has-error');
				$ibeToSelectize.addClass('select-filled');
				$ibeToSelectize.removeClass('has-error');
			},
			onChange: function(value: any) {
				$ibeToBookingTitle.addClass('input-filled');
				$ibeToSelectize.addClass('select-filled');

				/* Handling passenger type for uk cities */
				if (ukCities.includes(value) || ukCities.includes($ibeFromLocation.val())) {
					$('.passenger-details-selected .teenager-cat').css('display', 'block');
					$('.passenger-details-selected .is-uk').css('display', 'block');
					$('.passenger-details-selected .isnt-uk').css('display', 'none');
					_self.isUkCitySelectedForIbeSearch = true;
				} else {
					$('.passenger-details-selected .isnt-uk').css('display', 'block');
					$('.passenger-details-selected .teenager-cat').css('display', 'none');
					$('.passenger-details-selected .is-uk').css('display', 'none');
					_self.isUkCitySelectedForIbeSearch = false;
					_self.$instance.find('.passenger-details-selected .ticket-teenager--input').val(0).trigger('change');
				}

				if ($ibeFromLocation.val() === $ibeToLocation.val()) {
					$ibeToSelectize.addClass('has-error');
					$ibeToBookingTitle.addClass('has-error');
				}
				else {
					$ibeToSelectize.removeClass('has-error');
					$ibeToBookingTitle.removeClass('has-error');
				}

				if ($ibeToLocation.val().trim() != "" && !_self.recentSearchActive) {
					setTimeout(function() {
						if(!$('#oneWayTripDateSelector').is(':visible')) {
							if ( $('#returnTripDateSelector').find('.departureDate').val()=='') {
								$returnTripDateSelectorById.find('input[name="start"]').focus();
							}
						} else {
							if ( $('#oneWayTripDateSelector').find('.departureDate').val()=='') {
								$oneWayTripDateSelectorById.find('input[name="start"]').focus();
							}
						}
					}, 200);
				}				
			},
			onBlur: function() {
				let $toLocationChange = $ibeToLocation.find('option:selected').text();
	
				if ($toLocationChange == '') {
					$ibeToBookingTitle.removeClass('input-filled');
					$ibeToSelectize.removeClass('select-filled');
				} else {
					$ibeToBookingTitle.addClass('input-filled');
					$ibeToSelectize.addClass('select-filled');
				}
			},
			onLoad: function(data:any) {
				_self.fillToPrepopValue($ibeToLocation[0].selectize);
				$ibeToLocation[0].selectize.trigger('blur');
			},
			lockOptgroupOrder: true,
			searchField      : ['text', 'optgroup'],
			selectOnTab      : true
		});


		let $multiCityDestGroup = _self.$instance.find('.multi-city--destination-group');

		$multiCityDestGroup.each(function(i:number){
			// MultiCity From Location event handlers
			let $mcityFromLocation:any     = $(this).find('.multicity-from--location'),
				$mcityFromBookingTitle:any = $(this).find('.mc-from--location .booking-form--title'),
				$mcityFromSelectize:any,
				$mcityFromSelectInput:any  = $(this).find('select.mc-from--location'),
				$bookdateSelector:any      = $(this).find('.book-date--selector');
				let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

			$mcityFromLocation.html(listItems);
			$mcityFromLocation.selectize({
				onInitialize: function() {
					_self.wcag.selectizeInputAria($mcityFromLocation[0].selectize);
					$mcityFromSelectize = $($mcityFromLocation[0].selectize.$control[0]);
				},
				onFocus: function() {
				_self.expandIbe(curInstance);
// $searchContainer.show();
// $searchContainer.parent().addClass('expanded');
					$mcityFromBookingTitle.addClass('input-filled');
					$mcityFromSelectize.addClass('select-filled');
					$bookdateSelector.removeClass('datepicker-selected');
					$mcityFromSelectize.removeClass('has-error');
					$mcityFromBookingTitle.removeClass('has-error');
				},
				onChange: function(value:any) {
					let mcityFromLocationValue:any = $mcityFromLocation.val();
					let toLocationEl:any = $($multiCityDestGroup[i]).find('select.multicity-to--location');
					if (value.length) {
						 // only get new toLocation values if fromLocation val is filled (do nothing if empty value)
						_self.bcommon.updateAirportOnDListOnFlowChange("Revenue", mcityFromLocationValue, toLocationEl);
					}
					$mcityFromBookingTitle.addClass('input-filled');
					$mcityFromSelectize.addClass('select-filled');
				},
				onBlur: function() {
					let $multiFromLocationVal = $mcityFromLocation.parent().find("option:selected").text();
					if ($multiFromLocationVal == '') {
						$mcityFromBookingTitle.removeClass('input-filled');
						$mcityFromSelectize.removeClass('select-filled');
					} else {
						$mcityFromBookingTitle.addClass('input-filled');
						$mcityFromSelectize.addClass('select-filled');
					}
				},
				onLoad: function(data:any) {
					$mcityFromLocation[0].selectize.trigger('blur');
				},
				lockOptgroupOrder: true,
				searchField: ['text', 'optgroup'],
				selectOnTab: true
			});

			/** MultiCity To Location event handlers*/
			let $mcityToLocation:any     = $(this).find('.multicity-to--location'),
				$mcityToBookingTitle:any = $(this).find('.mc-to--location .booking-form--title'),
				$mcityToSelectize:any,
				$mcityToSelectInput:any  = $(this).find('select.mc-to--location');

			$mcityToLocation.html(listItems);
			$mcityToLocation.selectize({
				onInitialize: function() {
					_self.wcag.selectizeInputAria($mcityToLocation[0].selectize);
					$mcityToSelectize = $($mcityToLocation[0].selectize.$control[0]);
				},
				onFocus: function() {
					$mcityToBookingTitle.addClass('input-filled');
					$mcityToSelectize.addClass('select-filled');
					$bookdateSelector.removeClass('datepicker-selected');
					$mcityToSelectize.removeClass('has-error');
					$mcityToBookingTitle.removeClass('has-error');
				},
				onChange: function(value: any) {
					$mcityToBookingTitle.addClass('input-filled');
					$mcityToSelectize.addClass('select-filled');
					if ($mcityFromLocation.val() === $mcityToLocation.val()) {
						$mcityToSelectize.addClass('has-error');
						$mcityToBookingTitle.addClass('has-error');
					}
					else {
						$mcityToSelectize.removeClass('has-error');
						$mcityToBookingTitle.removeClass('has-error');
					}
				},
				onBlur: function() {
					let $multiToLocationVal = $mcityToLocation.parent().find("option:selected").text();
					if ($multiToLocationVal == '') {
						$mcityToBookingTitle.removeClass('input-filled');
						$mcityToSelectize.removeClass('select-filled');
					} else {
						$mcityToBookingTitle.addClass('input-filled');
						$mcityToSelectize.addClass('select-filled');
					}
				},
				onLoad: function(data:any) {
					_self.fillToPrepopValue($mcityToLocation[0].selectize);
					$mcityToLocation[0].selectize.trigger('blur');
				},
				lockOptgroupOrder: true,
				searchField: ['text', 'optgroup'],
				selectOnTab: true
			});
		});
	
	
		setTimeout(() => {
			this.$scope.find('input').attr("autocomplete", "new-password");
			this.$scopeMob.find('input').attr("autocomplete", "new-password");
		}, 1800);
	
	}



	/**
	 * pre-populate ibe on load with data attached via data-attributes
	 * only for DESKTOP ibe
	 * - extend method to accept params (data,instance) to manually invoke and
	 *   populate topnav ibe for deep link
	 */
	populateOnload(data?:ibeTripData, instance?:any): void {
		let _self = this;
		let tripData:ibeTripData = {};

		// use current instance and dataset of instance if not passed into method
		if (instance === undefined) {
			instance = _self.$instance;
		}

		if (data === undefined) {
			tripData = _self.$instance.data();

			// cast date params as string
			if (tripData.fromDate) {
				tripData.fromDate = tripData.fromDate.toString();
			}
			if (tripData.toDate) {
				tripData.toDate = tripData.toDate.toString();
			}
		} else {
			tripData = data;
		}

		// trip type (set first as current behavior wipes input fields after change)
		// use promise to determine completion before setting other fields
		let tripTypeSet = $.Deferred();

		switch (tripData.triptype) {
			case 'R':
			case 'return':
				instance.find('.trip-type--container .returnTrip').trigger('click.triptype', tripTypeSet.resolve(tripData.triptype));
				break;
			case 'O':
			case 'oneway':
				instance.find('.trip-type--container .oneWayTrip').trigger('click.triptype', tripTypeSet.resolve(tripData.triptype));
				break;
			case 'M':
			case 'multicity':
				instance.find('.trip-type--container .multiCityTrip').trigger('click.triptype', tripTypeSet.resolve(tripData.triptype));
				break;
			default:
				tripTypeSet.resolve('R'); // retain default (return) and resolve promise
				break;
		}

		tripTypeSet.promise();

		$.when(tripTypeSet).done((triptype:string) => {
			// payment type (set before OnD)
			// if multicity flow is set, don't change payment type to miles
			let $paymentTypeInput = instance.find('.payment-method-options');
			switch (tripData.paymentType) {
				case 'C':
				case 'cash':
					$paymentTypeInput.find('input[name="cash_miles_type"][value="cash"]').prop('checked', true).click();
					break;
				case 'M':
				case 'miles':
					if (triptype !== 'M') {
						$paymentTypeInput.find('input[name="cash_miles_type"][value="miles"]').prop('checked', true).click();
					}
					break;
				case 'CM':
				case 'cash_miles':
					if (triptype !== 'M') {
						$paymentTypeInput.find('input[name="cash_miles_type"][value="cash_miles"]').prop('checked', true).click();
					}
					break;
				default:
					break;
			}

			// ond fields
			switch (triptype) {
				case 'R':
				case 'return':
				case 'O':
				case 'oneway':
					// assign "to location" value to prepop into class variable
					// (to await completion of updating "from location")
					// following which the "to location" value will be populated
					if (tripData.toLoc !== undefined) {
						_self.toPrepop = tripData.toLoc;
					}

					// from location (selectize instance)
					if (tripData.fromLoc !== undefined) {
						let $fromLocationInput = instance.find('select.mholidays-ibe-from--location')[0].selectize;
						$fromLocationInput.setValue(tripData.fromLoc);
					}
					break;
				case 'M':
				case 'multicity':
					let $mcFromLocationInput = instance.find('select.multicity-from--location');

					// assumes ond values are provided as comma separated string
					// ie. KUL,SIN,PEN,HKG
					// split and store as array for applying into multicty ond fields
					let $mcFromDataArr = tripData.fromLoc.split(',');
					let $mcToDataArr = tripData.toLoc.split(',');

					$mcFromLocationInput.each((i:number, el:any) => {
						// assign "to location" value to prepop into class variable
						// (to await completion of updating "from location")
						// following which the "to location" value will be populated
						_self.toPrepop = $mcToDataArr[i];
						el.selectize.setValue($mcFromDataArr[i]);
					});
					break;
				default:
					break;
			}

			// passengers input
			// populate values into input fields and trigger change to update displayed total value
			// adult
			if (tripData.psgAdult !== undefined) {
				let $psgAdultInput = instance.find('.minus-plus-input.passengersAdult');
				$psgAdultInput.val(parseInt(tripData.psgAdult)).trigger('change');
			}

			// teenager
			/*if (tripData.psgTeenager !== undefined) {
				let $psgTeenagerInput = instance.find('.minus-plus-input.passengersTeenager');
				$psgTeenagerInput.val(parseInt(tripData.psgTeenager)).trigger('change');
			}*/

			// child
			if (tripData.psgChild !== undefined) {
				let $psgChildInput = instance.find('.minus-plus-input.passengersChildren');
				$psgChildInput.val(parseInt(tripData.psgChild)).trigger('change');
			}

			// infant
			if (tripData.psgInfant !== undefined) {
				let $psgInfantInput = instance.find('.minus-plus-input.passengersInfant');
				$psgInfantInput.val(parseInt(tripData.psgInfant)).trigger('change');
			}

			/**
			 * test validity of date value for single trip
			 * criteria:
			 * - not undefined
			 * - string length > 0
			 * - string does not contain commas (multicity)
			 * @param {string} testString
			 */
			let validSingleDate = function (testString:string) {
				return (testString !== undefined && testString.length > 0 && testString.indexOf(',') < 0);
			};

			// travel dates (set last, should only happen after trip type has been set)
			// set date and trigger blur to set input field focus state
			// if trip type is return/oneway, don't populate datefields if multicity format is detected (comma present)
			switch (triptype) {
				case 'R':
				case 'return':
					// from date
					if (validSingleDate(tripData.fromDate)) {
						let $fromDateInput = instance.find('.returnTrip .departureDate');
						$fromDateInput.datepicker('setDate', moment(tripData.fromDate, 'YYYYMMDD').toDate()).trigger('blur', 'input');
					}
					// to date
					if (validSingleDate(tripData.toDate)) {
						let $toDateInput = instance.find('.returnTrip .returnDate');
						$toDateInput.datepicker('setDate', moment(tripData.toDate, 'YYYYMMDD').toDate()).trigger('blur', 'input');
					}
					break;

				case 'O':
				case 'oneway':
					// oneway from date
					if (validSingleDate(tripData.fromDate)) {
						let $owFromDateInput = instance.find('.oneWayTrip .departureDate');
						$owFromDateInput.datepicker('setDate', moment(tripData.fromDate, 'YYYYMMDD').toDate()).trigger('blur', 'input');
					}
					break;

				case 'M':
				case 'multicity':
					let $mcFromDateInput = instance.find('.multi-city--destination-group .dateDeparture');
					// assumes dep date values are provided as comma separated string
					// ie. 20180410,20180411,20180412

					let $mcFromDateArr = tripData.fromDate.split(',');
					let $mcAddFlightBtn = instance.find('.addAnotherFlight');
					$mcFromDateInput.each((i:number, el:any) => {
						// if more than 2 trips for multicity, trigger click on add flight button to display new ond option
						if (i > 1 && $mcFromDateArr[i]) {
							$mcAddFlightBtn.click();
						}
						if ($mcFromDateArr[i] !== undefined && $mcFromDateArr[i].toString().length > 0) {
							$(el).datepicker('setDate', moment($mcFromDateArr[i], 'YYYYMMDD').toDate()).trigger('blur', 'input');
						}
					});
					break;
			}

			// cabin class
			let $cabinClassInput = instance.find('select.cabin-class')[0].selectize;
  		switch (tripData.cabinType) {
  			case 'F':
  			case 'CFFFIRST':
  				$cabinClassInput.setValue('CFFFIRST');
	  			break;
  			case 'B':
  			case 'CFFBUS':
  				$cabinClassInput.setValue('CFFBUS');
	  			break;
  			case 'E':
  			case 'CFFECO':
  				$cabinClassInput.setValue('CFFECO');
	  			break;
	  		default:
	  			break;
  		}

  		// coupon code
  		let $couponCodeInput = instance.find('.couponcode-input');
  		if (tripData.couponCode !== undefined) {
  			$couponCodeInput.val(tripData.couponCode).trigger('blur');
  		}
		});
		let isedge = navigator.userAgent.indexOf("Edge") > -1;		
		let isexplorer= typeof document !== 'undefined' && !!(document as any).documentMode && !isedge;
		if (isedge || isexplorer) {
			$( '.hotelInputClass' ).on( 'click', function() {
				$( this ).prop( 'readonly', '' );
				$( this ).focus();
			});
			// making the input readonly
			$( '.hotelInputClass' ).on( 'blur', function() {
				$( this ).prop( 'readonly', 'readonly' );
			});
		}
	}

	/**
	 * fill prepop value to this select if waiting prepop value is present
	 */
	fillToPrepopValue(el:any):void {
		let _self = this;
		let val = _self.toPrepop;

		if (val) {
			el.setValue(val);
			_self.toPrepop = null;
		}
	}

}

let scope: any = document.querySelector('[data-ibe--mholidays]');
let bookingformcommon = new bookingFormCommon();

if (scope) {
	try {
		window['mHolidaysOnDList'] = $.Deferred();
		bookingformcommon.mHolidayslist().done((listData: any) => {
			window['mHolidaysOnDList'].resolve(listData);
		});
		window['mHolidaysOnDList'].promise();
		window['mHolidaysHotelsList'] = $.Deferred();
		bookingformcommon.hotelListNew().done((listData: any) => {
			window['mHolidaysHotelsList'].resolve(listData);
		});
		window['mHolidaysHotelsList'].promise();
		bookingformcommon.populateTuiHotelList($('#mholiday-ibe--container'));

		let mholidaysBookflight = new mholidayBookingFormContent();
		let bookflightinfant = new bookingFormInfant();
		var adobeDataLayer = new adobeDataLayerWrapper();

		// start: init navbar behavior
		mholidaysBookflight.nav();
		mholidaysBookflight.init();
		mholidaysBookflight.closeIbeHandler();
		// end: init navbar behavior

		let desktopIBEss: any = document.querySelectorAll('[data-ibe--mholidays]');
		let numDesktopIBEa: number = desktopIBEss.length - 1;
		let lastOnDDone: any = $.Deferred();

		Array.prototype.map.call(desktopIBEss, function (instance: any, i: number) {
			$.when(window['mHolidaysOnDList']).done((listData: any) => {
				mholidaysBookflight.setInstance(instance);
				mholidaysBookflight.createDesktopErrorValidationList();
				mholidaysBookflight.ibeSingleFormSubmitHandler();
				mholidaysBookflight.getOfficeCode();
				mholidaysBookflight.ibeTripType();
				mholidaysBookflight.calendarComponent();
				mholidaysBookflight.passengerDetailsHotel();
				mholidaysBookflight.passengerDetailsFlightHotel();
				mholidaysBookflight.passengerType();
				//mholidaysBookflight.populateTuiHotelList()

				let listItems: string = bookingformcommon.parseOnDListItems(listData, 'mholiday');
				mholidaysBookflight.initSelectize(listItems);
				bookflightinfant.toggleSubmitBtnDisplay(instance);
				mholidaysBookflight.populateOnload();

				if (numDesktopIBEa == i) {
					lastOnDDone.resolve();
				}
			});
		});

		lastOnDDone.promise();

		$.when(lastOnDDone).done(() => {
			//mholidaysBookflight.deeplink();
		});

		bookflightinfant.closeBtns();
	} catch (e) { console.error(e); }
}